// extracted by mini-css-extract-plugin
export default {"button":"Button-module--button--3AzjM"};